import React from "react";

export default function InfoContainer({ children, theme = "blue" }) {
  const themes = {
    blue: {
      gradient: "linear-gradient(135deg, #4d9fff 0%, #1e62ff 100%)",
      glow: "0 0 25px rgba(30,98,255,0.45)",
    },
    purple: {
      gradient: "linear-gradient(135deg, #b56bff 0%, #7200ff 100%)",
      glow: "0 0 25px rgba(114,0,255,0.45)",
    },
    green: {
      gradient: "linear-gradient(135deg, #3fe099 0%, #00a86b 100%)",
      glow: "0 0 25px rgba(0,168,107,0.45)",
    },
    orange: {
      gradient: "linear-gradient(135deg, #ffa45c 0%, #ff6b00 100%)",
      glow: "0 0 25px rgba(255,107,0,0.45)",
    },
    pink: {
      gradient: "linear-gradient(135deg, #ff7ad1 0%, #ff2e93 100%)",
      glow: "0 0 25px rgba(255,46,147,0.45)",
    },
  };

  const selected = themes[theme] || themes.blue;

  return (
    <div  align="center" className="">

      <div
        style={{
          width: "100%",
          maxWidth: "900px",
          padding: "50px 40px",
          background: "rgba(255,255,255,0.15)",
          borderRadius: "28px",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          border: "2px solid rgba(255,255,255,0.25)",
          position: "relative",
          overflow: "hidden",
          boxShadow: `0 20px 40px rgba(0,0,0,0.25), ${selected.glow}`,
          animation: "floatIn 1.2s ease",
        }}
      >
        {/* Gradient Glow Ring */}
        <div
          style={{
            position: "absolute",
            inset: "0",
            background: selected.gradient,
           
           
            zIndex: "-1",
            paddingLeft: "20px",
          }}
        >

        <p
          className="text-left"
          style={{
            fontSize: "22px",
            lineHeight: "1.3",
            fontWeight: "600",
            color: "#f7f3f3ff",
            textShadow: "0 1px 1px rgba(255,255,255,0.6)",
            animation: "riseUp 1.1s ease",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          {children}
          <br/>
        </p>
        </div>

        {/* Animations */}
        <style>
          {`
            @keyframes floatIn {
              from { opacity: 0; transform: translateY(35px) scale(0.95); }
              to { opacity: 1; transform: translateY(0) scale(1); }
            }

            @keyframes riseUp {
              from { opacity: 0; transform: translateY(30px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
      </div>
    </div>
  );
}
